import form from "./form/zhTW";

export default {
    form: form
}
